import { activityTimestamp } from "./activityBoardState";

export function activityDateRange(selection, now = new Date()) {
  if (!selection || selection === "All Time") return {};
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 1);
  if (selection === "This Week") start.setDate(start.getDate() - (start.getDay() + 6) % 7);
  else if (selection === "Last 7 Days") start.setDate(start.getDate() - 6);
  else if (selection === "This Month") start.setDate(1);
  else if (selection !== "Today") return {};
  return { dateStart: start.toISOString(), dateEnd: end.toISOString() };
}

export function matchesActivityDate(card, selection, now = new Date()) {
  const { dateStart, dateEnd } = activityDateRange(selection, now);
  if (!dateStart) return true;
  const completed = Number(card.completedSortTime);
  const timestamp = card.state === "complete" && Number.isFinite(completed) && completed > 0
    ? completed : activityTimestamp(card.createdAt);
  return Number.isFinite(timestamp) && timestamp >= Date.parse(dateStart) && timestamp < Date.parse(dateEnd);
}
